import { eFormElementType } from "../../../services/Enums/shared";
 
export interface IFormElementConfig {
    label:string;
    dataProperty:string;
    show:boolean;
    originalValue?:string;
    correctedValue?:string;
    inputType:eFormElementType;
    correctedValueEditable?:boolean;
    enableEditing?:boolean;
    dropdownGroupName?:string;
    calculatedValue?:string;
    colSpan?:number;
    formatDropdownValuesToIncludeName?:boolean;
    validationFormIoComponents: string[];
    allowValueClearing?: boolean;
}

export class FormElementConfig implements IFormElementConfig {
    constructor(
        public label:string,
        public show:boolean,
        public dataProperty:string,
        public inputType:eFormElementType,
        public validationFormIoComponents:string[],
        public dropdownGroupName?:string,
        public originalValue?:string,
        public correctedValue?:string,
        public correctedValueEditable?:boolean,
        public enableEditing?:boolean,
        public calculatedValue?:string,
        public colSpan?:number,
        public formatDropdownValuesToIncludeName?:boolean,
        public allowValueClearing?:boolean) { }

}